import { useInfiniteQuery } from 'react-query';
import { documentsService } from 'hq/services';
import { QUERY_KEYS } from 'api/query-keys';
import { DocumentsParams } from '../../documents-type';

export const useGetDocuments = (filterParams: DocumentsParams) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.documentsWithFilters(filterParams),
    queryFn: async ({ pageParam = 0 }) => {
      return documentsService.getDocuments({
        pageParam,
        pageSizeParam: 30,
        status: filterParams.status,
        documentType: filterParams.documentType,
        name: filterParams.name,
      });
    },

    getNextPageParam: (lastGroup) => lastGroup.nextPage,
    keepPreviousData: true,
  });
};
